import React, { useState, useEffect } from "react";
import { Container, ListGroup, Button, Spinner, Alert, Card, Badge } from "react-bootstrap";

import { Link ,useParams} from "react-router-dom";
import { useNavigate } from "react-router-dom";
const TestList = ({ testI }) => {
const { testId } = useParams();
   const [tests, setTests] = useState([]);
 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [hoveredId, setHoveredId] = useState(null);

  const handleLogin = () => {
    localStorage.clear();
    window.location.href = "/";
  };

 useEffect(() => {
  
    const fetchTests = async () => {
      try {
        const response = await fetch(
        `https://testresult.omegacareerinstitute.com/admin/welcome/get_tests/${testId}/${localStorage.getItem("rollno")}`
        );
        const responseData = await response.json();

        const testsArray = responseData.data || [];

        if (!Array.isArray(testsArray)) {
          throw new Error("Invalid data format: Expected an array");
        }

        const sortedTests = testsArray.sort((a, b) => new Date(b.entrydate) - new Date(a.entrydate));
        setTests(sortedTests);
      } catch (error) {
        console.error("Failed to fetch tests:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTests();
  }, []);

  return (
     <Container>
      {/* Top Bar */}
      <div
        style={{ color: "rgb(99 33 39)" }}
        className="header p-3 d-flex justify-content-between align-items-center rounded"
      >
        <div className="user-details">
          <h5 className="mb-1">Name: {localStorage.getItem("name")}</h5>
          <h6 className="mb-1">Father Name: {localStorage.getItem("father")}</h6>
          <h6 className="mb-0">Roll No.: {localStorage.getItem("rollno")}</h6>
        </div>
        <Button variant="light" className="fw-bold" onClick={handleLogin}>
          Logout
        </Button>
      </div>

      {/* Top Image */}
      <img
        src="https://testresult.omegacareerinstitute.com/What-is-Test-Plan-1.png"
        alt="Top Banner"
        className="img-fluid mb-4"
        style={{ borderRadius: "10px" }}
      />

   <ListGroup>
  {tests.map((test) => (
    <Link
      to={test.showName === "No Data Available" ? "#" : `/detail/${test.id}`}
      key={test.id}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <ListGroup.Item
        className="justify-content-between align-items-start mb-2 shadow-sm"
        style={{
          borderRadius: "10px",
          transition: "opacity 0.3s ease-in-out",
          cursor: "pointer",
          opacity: hoveredId === test.id ? 0.7 : 1,
        }}
        onMouseEnter={() => setHoveredId(test.id)}
        onMouseLeave={() => setHoveredId(null)}
      >
        <div
          style={{
            background: "#ffffff",
            borderRadius: "16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          {/* LEFT SIDE TEXT */}
          <div style={{ fontSize: "14px", lineHeight: "1.3" }}>
            <div><strong>{test.showName}</strong></div>
            <div>{test.name}</div>
            <div>{test.date}</div>
            <div>{test.resultAnnounce}</div>
          </div>

          {/* RIGHT BUTTON (only if showName is NOT No Data Available) */}
          {test.showName !== "No Data Available" && (
            <button
              className="btn btn-primary"
              style={{
                borderRadius: "25px",
                fontSize: "14px",
                whiteSpace: "nowrap",
              }}
            >
              View
            </button>
          )}
        </div>
      </ListGroup.Item>
    </Link>
  ))}
</ListGroup>

    </Container>
  );
};

export default TestList;
